export type ValueCode =
    | "bienveillance"
    | "respect"
    | "faire-equipe"
    | "engagement";

export type OverviewScope = "pole" | "services";
export type EvolutionDirection = "up" | "down" | "stable" | "no-data";

export const VALUE_CODES: ValueCode[] = [
    "bienveillance",
    "respect",
    "faire-equipe",
    "engagement"
];

export const VALUE_LABELS: Record<ValueCode, string> = {
    bienveillance: "Bienveillance",
    respect: "Respect",
    "faire-equipe": "Faire équipe",
    engagement: "Engagement"
};

export interface PoleViewModel {
    id: string;
    name: string;
    reference: string;
}

export interface ServiceViewModel {
    id: string;
    name: string;
    reference: string;
    poleReference: string;
}

export interface ValueScoreViewModel {
    code: ValueCode;
    label: string;
    score?: number;
    percentage?: number;
    status: "available" | "no-data";
}

export interface ServiceScoreViewModel {
    service: ServiceViewModel;
    /** Résultats de la période courante. */
    values: Record<ValueCode, ValueScoreViewModel>;
    averageScore?: number;
    /** Résultats de la période précédente comparable. */
    previousValues?: Record<ValueCode, ValueScoreViewModel>;
    previousAverageScore?: number;
    /** Variation de la moyenne, exprimée en points sur l'échelle 0-100. */
    evolution?: number;
    evolutionDirection?: EvolutionDirection;
}

export interface PoleDashboardViewModel {
    pole: PoleViewModel;
    services: ServiceScoreViewModel[];
    poleScores: Record<ValueCode, ValueScoreViewModel>;
}
